"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetPassword = exports.setPassword = exports.updatePassword = exports.auth = exports.login = exports.isAuthenticating = exports.logout = exports.removeUserToken = exports.getUserToken = exports.setUserToken = exports.receiveAuthResponse = exports.IS_AUTHENTICATING = exports.UPDATE_USER = exports.AUTH_FAILURE = exports.USER_LOGOUT = exports.USER_LOGIN = void 0;

var _avlComponents = require("@availabs/avl-components");

var _utils = require("./utils");

var USER_LOGIN = 'AMS::USER_LOGIN';
exports.USER_LOGIN = USER_LOGIN;
var USER_LOGOUT = 'AMS::USER_LOGOUT';
exports.USER_LOGOUT = USER_LOGOUT;
var AUTH_FAILURE = 'AMS::AUTH_FAILURE';
exports.AUTH_FAILURE = AUTH_FAILURE;
var UPDATE_USER = 'AMS::UPDATE_USER';
exports.UPDATE_USER = UPDATE_USER;
var IS_AUTHENTICATING = 'AMS::IS_AUTHENTICATING';
exports.IS_AUTHENTICATING = IS_AUTHENTICATING;

var receiveAuthResponse = function receiveAuthResponse(user) {
  return {
    type: USER_LOGIN,
    user: user
  };
};

exports.receiveAuthResponse = receiveAuthResponse;

var setUserToken = function setUserToken(user) {
  if (window.localStorage) {
    window.localStorage.setItem('userToken', user.token);
  }
};

exports.setUserToken = setUserToken;

var getUserToken = function getUserToken(user) {
  if (window.localStorage) {
    return window.localStorage.getItem('userToken');
  }

  return null;
};

exports.getUserToken = getUserToken;

var removeUserToken = function removeUserToken() {
  if (window.localStorage) {
    window.localStorage.removeItem('userToken');
  }
};

exports.removeUserToken = removeUserToken;

var logout = function logout() {
  return function (dispatch) {
    return Promise.resolve(dispatch({
      type: USER_LOGOUT
    }));
  };
};

exports.logout = logout;

var isAuthenticating = function isAuthenticating() {
  return {
    type: IS_AUTHENTICATING
  };
};

exports.isAuthenticating = isAuthenticating;

var login = function login(email, password) {
  return function (dispatch) {
    var _Config = (0, _utils.Config)(),
        AUTH_HOST = _Config.AUTH_HOST,
        PROJECT_NAME = _Config.PROJECT_NAME;

    dispatch(isAuthenticating());
    return (0, _utils.postJson)("".concat(AUTH_HOST, "/login"), {
      email: email,
      password: password,
      project: PROJECT_NAME
    }).then(function (res) {
      if (res.error) {
        dispatch({
          type: AUTH_FAILURE
        });
        dispatch((0, _avlComponents.sendSystemMessage)(res.error, {
          type: 'Danger'
        }));
      } else {
        dispatch(receiveAuthResponse(res.user));
      }
    })["catch"](function (error) {
      dispatch((0, _avlComponents.sendSystemMessage)('Cannot contact authentication server.'));
      dispatch({
        type: AUTH_FAILURE
      });
    });
  };
};

exports.login = login;

var auth = function auth() {
  var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUserToken();
  return function (dispatch) {
    if (token) {
      dispatch(isAuthenticating());
      return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/auth"), {
        token: token,
        project: _utils.Config.PROJECT_NAME
      }).then(function (res) {
        if (res.error) {
          dispatch({
            type: AUTH_FAILURE
          });
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          dispatch(receiveAuthResponse(res.user));
        }
      })["catch"](function (error) {
        dispatch((0, _avlComponents.sendSystemMessage)('Cannot contact authentication server.'));
        dispatch({
          type: AUTH_FAILURE
        });
      });
    }

    return dispatch({
      type: AUTH_FAILURE
    });
  };
};

exports.auth = auth;

var updatePassword = function updatePassword(current, password) {
  return function (dispatch, getState) {
    var token = getState().user.token;

    if (token) {
      return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/password/update"), {
        token: token,
        current: current,
        password: password
      }).then(function (res) {
        if (res.error) {
          return dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          setUserToken(res);
          dispatch((0, _avlComponents.sendSystemMessage)(res.message));
          return dispatch({
            type: UPDATE_USER,
            update: {
              token: res.token
            }
          });
        }
      });
    }

    return Promise.resolve();
  };
};

exports.updatePassword = updatePassword;

var setPassword = function setPassword(token, password) {
  return function (dispatch) {
    var _Config2 = (0, _utils.Config)(),
        AUTH_HOST = _Config2.AUTH_HOST,
        CLIENT_HOST = _Config2.CLIENT_HOST;

    return (0, _utils.postJson)("".concat(AUTH_HOST, "/password/set"), {
      token: token,
      password: password,
      host: CLIENT_HOST,
      url: "/auth/set-passord"
    }).then(function (res) {
      if (res.error) {
        dispatch((0, _avlComponents.sendSystemMessage)(res.error));
      } else {
        if (res.message) {
          dispatch((0, _avlComponents.sendSystemMessage)(res.message));
        }

        return dispatch(auth(res.token));
      }
    });
  };
};

exports.setPassword = setPassword;

var resetPassword = function resetPassword(email) {
  return function (dispatch) {
    var _Config3 = (0, _utils.Config)(),
        AUTH_HOST = _Config3.AUTH_HOST,
        PROJECT_NAME = _Config3.PROJECT_NAME,
        CLIENT_HOST = _Config3.CLIENT_HOST;

    return (0, _utils.postJson)("".concat(AUTH_HOST, "/password/reset"), {
      email: email,
      project_name: PROJECT_NAME,
      host: CLIENT_HOST,
      url: "/auth/set-password"
    }).then(function (res) {
      if (res.error) {
        dispatch((0, _avlComponents.sendSystemMessage)(res.error));
      } else {
        dispatch((0, _avlComponents.sendSystemMessage)(res.message));
      }
    });
  };
};

exports.resetPassword = resetPassword;